/* JB: carrosseis do Judge.me — um card por avaliacao e por cliente (mesmo nome nao repete), em vez de um por foto.
   A resposta de reviews_for_carousel vem com uma entrada por midia; aqui fica so a primeira
   de cada avaliacao (preferindo video quando houver). */
(function(){
  if(!window.fetch||window.__jbJdgmUnico)return; window.__jbJdgmUnico=true;
  var orig=window.fetch;
  window.fetch=function(input,init){
    var url=''; try{url=typeof input==='string'?input:(input&&input.url)||''}catch(e){}
    var p=orig.apply(this,arguments);
    if(url.indexOf('reviews_for_carousel')===-1)return p;
    return p.then(function(res){
      if(!res||!res.ok)return res;
      return res.clone().json().then(function(d){
        if(!d||!Array.isArray(d.reviews))return res;
        var pos={},out=[],nomes={};
        d.reviews.forEach(function(r){
          var k=r.uuid||r.id; if(k==null){out.push(r);return}
          if(pos[k]===undefined){var n=String(r.reviewer_name||'').trim().toLowerCase(); if(n&&!r.is_anonymous_reviewer){if(nomes[n])return; nomes[n]=1} pos[k]=out.length;out.push(r)}
          else if(r.card_type==='video'&&out[pos[k]].card_type!=='video'){out[pos[k]]=r}
        });
        d.reviews=out;
        return new Response(JSON.stringify(d),{status:res.status,statusText:res.statusText,headers:{'Content-Type':'application/json'}});
      }).catch(function(){return res});
    });
  };
})();
